import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M13.125 10.29a3.125 3.125 0 1 1-6.25 0 3.125 3.125 0 0 1 6.25 0m3.125 0a6.23 6.23 0 0 0-1.591-4.167.625.625 0 1 0-.932.833 5 5 0 0 1 0 6.667.626.626 0 0 0 .932.833 6.23 6.23 0 0 0 1.591-4.167M6.273 6.955a.625.625 0 1 0-.931-.833 6.245 6.245 0 0 0 0 8.333.625.625 0 0 0 .93-.833 4.996 4.996 0 0 1 0-6.667m12.366-.312a9.3 9.3 0 0 0-1.943-2.917.625.625 0 1 0-.892.875 8.117 8.117 0 0 1 0 11.372.627.627 0 0 0 .892.878A9.38 9.38 0 0 0 18.638 6.64zM2.512 13.452a8.12 8.12 0 0 1 1.683-8.849.625.625 0 0 0-.892-.876 9.365 9.365 0 0 0 0 13.125.625.625 0 1 0 .892-.875 8.1 8.1 0 0 1-1.683-2.525"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 .29h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }